import env from './env';

export const clioManageMatterLink = (matterId: number) =>
  `${env.clioBaseUrl}/nc/#/matters/${matterId}`;

export const clioManageMatterDocumentsLink = (matterId: number) =>
  `${clioManageMatterLink(matterId)}/documents`;
